import { LocalizedParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { useLocalizeCurrency } from '@mews/framework';
import { getCurrentEnterpriseDefaultCurrencyCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { MIN_REQUIRED_MONTHLY_PAYMENTS_AMOUNT } from '../../constants';

export const ListItemCardPaymentsLabel = () => {
    const enterpriseCurrencyCode: string = useCommanderSelector(getCurrentEnterpriseDefaultCurrencyCode);
    const localizeCurrency = useLocalizeCurrency();
    const formattedMinAmount = localizeCurrency(MIN_REQUIRED_MONTHLY_PAYMENTS_AMOUNT, enterpriseCurrencyCode, {
        maximumFractionDigits: 0,
    });

    return (
        <LocalizedParagraph
            textKey={TextKey.FinancialServicesCapitalHaveMonthlyCardPayments}
            substitutes={{ minAmount: formattedMinAmount }}
        />
    );
};
